/* @flow */

export default class ValidateReferencesRequest {
  sellerCompanyId: number;
  reference: string;
  debtorReference: string;

  constructor(sellerCompanyId: number, reference: string, debtorReference: string) {
    this.sellerCompanyId = sellerCompanyId;
    this.reference = reference;
    this.debtorReference = debtorReference;
  }
}
